export const FETCH_PREFERENTIAL_CATEGORIES = "FETCH_PREFERENTIAL_CATEGORIES";

export const INSERT_PREFERENTIAL_CATEGORY = "INSERT_FACULTYPREFERENTIAL_CATEGORY";

export const DELETE_PREFERENTIAL_CATEGORY = "DELETE_PREFERENTIAL_CATEGORY";

export const EDIT_PREFERENTIAL_CATEGORY_INFO = "EDIT_PREFERENTIAL_CATEGORY_INFO";
